"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

// @ts-ignore no module typings
var schema = (0, _reactDesc.describe)({
  displayName: 'OptionsList'
});

schema.makePropTypes = function () {
  return {
    defaultSelected: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.string)]).description('These IDs will appear as selected the first time the user opens the dropdown.'),
    actions: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object), _reactDesc.PropTypes.shape({
      left: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object),
      right: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object)
    })]).description('A collection of objects, each containing a subset of props valid for a Button component. Check the notes below.'),
    items: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
      decoration: _reactDesc.PropTypes.shape({
        type: _reactDesc.PropTypes.oneOf(['Avatar', 'Badge', 'Icon'])
      }),
      disabled: _reactDesc.PropTypes.bool,
      id: _reactDesc.PropTypes.string,
      label: _reactDesc.PropTypes.string.description('The label text for an option in the dropdown list.'),
      labelDetails: _reactDesc.PropTypes.string.description('The secondary sub-text for an option in the dropdown list.'),
      value: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.number, _reactDesc.PropTypes.string]).description('The value for an option in the dropdown list.')
    })).description('The array of item data that will be rendered').isRequired,
    minWidth: _reactDesc.PropTypes.string.description('A CSS min-width value to apply'),
    maxWidth: _reactDesc.PropTypes.string.description('A CSS max-width value to apply'),
    maxHeight: _reactDesc.PropTypes.string.description('A CSS max-height value to apply'),
    multiple: _reactDesc.PropTypes.bool.description('Enables multiple selections in the options list.'),
    name: _reactDesc.PropTypes.string.description("The input's name, to identify the input in the data in a form."),
    onChange: _reactDesc.PropTypes.func.description('Change event handler, called with the selected id or array of the selected item IDs.'),
    selected: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.string)]).description('Used when component is controlled. Defines the item(s) selected in the options list.'),
    renderOptionLabel: _reactDesc.PropTypes.func.description('Function to customize render of option labels, called with the item value.'),
    selectable: _reactDesc.PropTypes.bool.description('Enables selection in the options list.').defaultValue(true),
    role: _reactDesc.PropTypes.string.description('The role assigned to the list.').defaultValue('listbox'),
    itemRole: _reactDesc.PropTypes.string.description('The role assigned to each item in the list.').defaultValue('option')
  };
};

schema.propTypes = schema.makePropTypes();
var _default = schema;
exports.default = _default;